import { useTranslation } from 'react-i18next';
import CustomChip from '../../../../../components/CustomChip';
import { AVAILABILITY_MODEL, availabilityStatusStyles } from '../Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param {Object} props
 * @param {number} props.value - The available stock or quantity to determine availability status.
 */
const AvailabilityChip = ({ value }) => {
    const { t } = useTranslation();
    // Determine availability status based on the incoming value
    // If value > 0, it's considered AVAILABLE; otherwise, UNAVAILABLE
    const availability = value > 0 ? AVAILABILITY_MODEL.AVAILABLE : AVAILABILITY_MODEL.UNAVAILABLE;
    const styles = availabilityStatusStyles[availability];
    return (
        <div className='d-flex justify-content-center'>
            <CustomChip
                variant='large'
                legend={t(availability.toLowerCase())}
                background={styles.background}
                fontColor={styles.fontColor}
                borderColor={styles.borderColor}
            />
        </div>
    );
};

export default AvailabilityChip;
